import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'

const NotFoundPageView = () => {
    return (
        <MainLayout>
            Error 404: Page not found!
        </MainLayout>
    )
}

NotFoundPageView.propTypes = {

}

export default NotFoundPageView



// WEBPACK FOOTER //
// ./src/views/NotFound/index.jsx